var map = {
	"./404/404": [
		35897
	],
	"./404/404.js": [
		35897
	],
	"./a-page-template/a-page-template": [
		87917,
		9607,
		7917
	],
	"./a-page-template/a-page-template.js": [
		87917,
		9607,
		7917
	],
	"./a-page-template/a-page-template.scss": [
		69607,
		9607
	],
	"./about/about": [
		65316,
		484,
		5605,
		4123,
		5316
	],
	"./about/about.scss": [
		64123,
		4123
	],
	"./about/about.tsx": [
		65316,
		484,
		5605,
		4123,
		5316
	],
	"./adopters/adopters": [
		50874,
		1257,
		874
	],
	"./adopters/adopters.scss": [
		71257,
		1257
	],
	"./adopters/adopters.tsx": [
		50874,
		1257,
		874
	],
	"./adoption/adoption": [
		67430,
		8308,
		5848,
		6452,
		9178,
		670,
		5377,
		8050,
		588,
		9752,
		1445,
		2373,
		1386,
		7430
	],
	"./adoption/adoption.scss": [
		42373,
		2373
	],
	"./adoption/adoption.tsx": [
		67430,
		8308,
		5848,
		6452,
		9178,
		670,
		5377,
		8050,
		588,
		9752,
		1445,
		2373,
		1386,
		7430
	],
	"./adoption/how-using/how-using": [
		71445,
		9752,
		1445
	],
	"./adoption/how-using/how-using.scss": [
		29752,
		9752
	],
	"./adoption/how-using/how-using.tsx": [
		71445,
		9752,
		1445
	],
	"./ally-logos/ally-logos": [
		26492,
		8308,
		3491,
		4111
	],
	"./ally-logos/ally-logos.scss": [
		73491,
		3491
	],
	"./ally-logos/ally-logos.tsx": [
		26492,
		8308,
		3491,
		4111
	],
	"./assignable/assignable": [
		62793,
		8308,
		7201,
		6516,
		484,
		5605,
		9309,
		9238,
		9990,
		7954,
		2672,
		6046,
		8986,
		7234,
		5491,
		2630,
		856,
		1127,
		3820,
		6624,
		7152,
		7555
	],
	"./assignable/assignable.js": [
		62793,
		8308,
		7201,
		6516,
		484,
		5605,
		9309,
		9238,
		9990,
		7954,
		2672,
		6046,
		8986,
		7234,
		5491,
		2630,
		856,
		1127,
		3820,
		6624,
		7152,
		7555
	],
	"./assignable/assignable.scss": [
		75491,
		5491
	],
	"./assignable/sections/about/about": [
		33508,
		8308,
		7201,
		6516,
		9309,
		6046,
		1127
	],
	"./assignable/sections/about/about.js": [
		33508,
		8308,
		7201,
		6516,
		9309,
		6046,
		1127
	],
	"./assignable/sections/about/about.scss": [
		66046,
		6046
	],
	"./assignable/sections/banner/banner": [
		62630,
		5605,
		2672,
		2630
	],
	"./assignable/sections/banner/banner.js": [
		62630,
		5605,
		2672,
		2630
	],
	"./assignable/sections/banner/banner.scss": [
		2672,
		2672
	],
	"./assignable/sections/courses/courses": [
		10856,
		7954,
		856
	],
	"./assignable/sections/courses/courses.js": [
		10856,
		7954,
		856
	],
	"./assignable/sections/courses/courses.scss": [
		7954,
		7954
	],
	"./assignable/sections/cta/cta": [
		56624,
		7234,
		6624
	],
	"./assignable/sections/cta/cta.js": [
		56624,
		7234,
		6624
	],
	"./assignable/sections/cta/cta.scss": [
		7234,
		7234
	],
	"./assignable/sections/faq/faq": [
		47152,
		9238,
		8986,
		7152
	],
	"./assignable/sections/faq/faq.js": [
		47152,
		9238,
		8986,
		7152
	],
	"./assignable/sections/faq/faq.scss": [
		28986,
		8986
	],
	"./assignable/sections/overlapping-quote/overlapping-quote": [
		23820,
		9990,
		3820
	],
	"./assignable/sections/overlapping-quote/overlapping-quote.js": [
		23820,
		9990,
		3820
	],
	"./assignable/sections/overlapping-quote/overlapping-quote.scss": [
		29990,
		9990
	],
	"./blog/article-summary/article-summary": [
		84341,
		9593,
		2480,
		4341
	],
	"./blog/article-summary/article-summary.scss": [
		12584,
		2584
	],
	"./blog/article-summary/article-summary.tsx": [
		84341,
		9593,
		2480,
		4341
	],
	"./blog/article/article": [
		38489,
		8308,
		9593,
		1261,
		7512,
		951,
		240,
		8489
	],
	"./blog/article/article.scss": [
		97512,
		7512
	],
	"./blog/article/article.tsx": [
		38489,
		8308,
		9593,
		1261,
		7512,
		951,
		240,
		8489
	],
	"./blog/article/use-progress": [
		10240,
		1261,
		240
	],
	"./blog/article/use-progress.tsx": [
		10240,
		1261,
		240
	],
	"./blog/blog": [
		70430,
		8308,
		8023,
		9593,
		1261,
		2480,
		5447,
		9287,
		2837,
		6452,
		9178,
		5377,
		4735,
		676,
		4341,
		7512,
		5656,
		2560,
		951,
		4085,
		240,
		4205,
		8489,
		1930,
		6027,
		3302,
		4180,
		5513,
		3700,
		3674,
		430
	],
	"./blog/blog-context": [
		30676,
		676
	],
	"./blog/blog-context.tsx": [
		30676,
		676
	],
	"./blog/blog-pages": [
		61325,
		8308,
		8023,
		9593,
		1261,
		2480,
		5447,
		6452,
		9178,
		5377,
		4735,
		676,
		4341,
		7512,
		5656,
		2560,
		951,
		4085,
		240,
		4205,
		8489,
		1930,
		6027,
		3302,
		4180,
		5513,
		3700,
		3674,
		1757,
		2163,
		1325
	],
	"./blog/blog-pages.tsx": [
		61325,
		8308,
		8023,
		9593,
		1261,
		2480,
		5447,
		6452,
		9178,
		5377,
		4735,
		676,
		4341,
		7512,
		5656,
		2560,
		951,
		4085,
		240,
		4205,
		8489,
		1930,
		6027,
		3302,
		4180,
		5513,
		3700,
		3674,
		1757,
		2163,
		1325
	],
	"./blog/blog.scss": [
		41757,
		1757
	],
	"./blog/blog.tsx": [
		70430,
		8308,
		8023,
		9593,
		1261,
		2480,
		5447,
		9287,
		2837,
		6452,
		9178,
		5377,
		4735,
		676,
		4341,
		7512,
		5656,
		2560,
		951,
		4085,
		240,
		4205,
		8489,
		1930,
		6027,
		3302,
		4180,
		5513,
		3700,
		3674,
		430
	],
	"./blog/explore-page/explore-page": [
		13765,
		8308,
		9593,
		1261,
		2480,
		5447,
		2837,
		4735,
		676,
		4341,
		5656,
		2560,
		4085,
		4205,
		3765
	],
	"./blog/explore-page/explore-page.tsx": [
		13765,
		8308,
		9593,
		1261,
		2480,
		5447,
		2837,
		4735,
		676,
		4341,
		5656,
		2560,
		4085,
		4205,
		3765
	],
	"./blog/gated-content-dialog/gated-content-dialog": [
		32163,
		9178,
		5377,
		676,
		3302,
		2163
	],
	"./blog/gated-content-dialog/gated-content-dialog.scss": [
		83302,
		3302
	],
	"./blog/gated-content-dialog/gated-content-dialog.tsx": [
		32163,
		9178,
		5377,
		676,
		3302,
		2163
	],
	"./blog/latest-blog-posts/latest-blog-posts": [
		36861,
		8308,
		8023,
		9593,
		2480,
		5447,
		9287,
		2837,
		4735,
		676,
		4341,
		5656,
		4085,
		9936,
		6861
	],
	"./blog/latest-blog-posts/latest-blog-posts.scss": [
		39936,
		9936
	],
	"./blog/latest-blog-posts/latest-blog-posts.tsx": [
		36861,
		8308,
		8023,
		9593,
		2480,
		5447,
		9287,
		2837,
		4735,
		676,
		4341,
		5656,
		4085,
		9936,
		6861
	],
	"./blog/more-stories/more-stories": [
		44085,
		9593,
		2480,
		4735,
		676,
		4341,
		5656,
		4085
	],
	"./blog/more-stories/more-stories.scss": [
		95656,
		5656
	],
	"./blog/more-stories/more-stories.tsx": [
		44085,
		9593,
		2480,
		4735,
		676,
		4341,
		5656,
		4085
	],
	"./blog/pinned-article/pinned-article": [
		54205,
		9593,
		2480,
		4735,
		676,
		4341,
		2560,
		4205
	],
	"./blog/pinned-article/pinned-article.scss": [
		52560,
		2560
	],
	"./blog/pinned-article/pinned-article.tsx": [
		54205,
		9593,
		2480,
		4735,
		676,
		4341,
		2560,
		4205
	],
	"./blog/search-results/no-results": [
		83700,
		9593,
		2480,
		4735,
		676,
		4341,
		5656,
		2560,
		4085,
		4205,
		6027,
		3700
	],
	"./blog/search-results/no-results.scss": [
		76027,
		6027
	],
	"./blog/search-results/no-results.tsx": [
		83700,
		9593,
		2480,
		4735,
		676,
		4341,
		5656,
		2560,
		4085,
		4205,
		6027,
		3700
	],
	"./blog/search-results/search-results": [
		63674,
		8023,
		9593,
		2480,
		6452,
		4735,
		676,
		4341,
		5656,
		2560,
		4085,
		4205,
		6027,
		4180,
		5513,
		3700,
		3674
	],
	"./blog/search-results/search-results.scss": [
		94180,
		4180
	],
	"./blog/search-results/search-results.tsx": [
		63674,
		8023,
		9593,
		2480,
		6452,
		4735,
		676,
		4341,
		5656,
		2560,
		4085,
		4205,
		6027,
		4180,
		5513,
		3700,
		3674
	],
	"./blog/search-results/use-all-articles": [
		15513,
		8023,
		9593,
		2480,
		4341,
		5513
	],
	"./blog/search-results/use-all-articles.tsx": [
		15513,
		8023,
		9593,
		2480,
		4341,
		5513
	],
	"./confirmation/confirmation": [
		5140,
		8857,
		7633,
		3949,
		2579,
		9406,
		6306,
		2075,
		2428,
		5140
	],
	"./confirmation/confirmation.scss": [
		62075,
		2075
	],
	"./confirmation/confirmation.tsx": [
		5140,
		8857,
		7633,
		3949,
		2579,
		9406,
		6306,
		2075,
		2428,
		5140
	],
	"./contact/contact": [
		39036,
		2236,
		3399,
		8382,
		1395,
		9036
	],
	"./contact/contact.scss": [
		71395,
		1395
	],
	"./contact/contact.tsx": [
		39036,
		2236,
		3399,
		8382,
		1395,
		9036
	],
	"./contact/embedded": [
		835,
		2236,
		3399,
		8382,
		5911,
		835
	],
	"./contact/embedded.js": [
		835,
		2236,
		3399,
		8382,
		5911,
		835
	],
	"./contact/embedded.scss": [
		15911,
		5911
	],
	"./contact/form": [
		58382,
		2236,
		3399,
		8382
	],
	"./contact/form.scss": [
		53399,
		3399
	],
	"./contact/form.tsx": [
		58382,
		2236,
		3399,
		8382
	],
	"./details/common/authors": [
		27578,
		8023,
		7427,
		7578
	],
	"./details/common/authors.tsx": [
		27578,
		8023,
		7427,
		7578
	],
	"./details/common/common": [
		79511,
		8023,
		7427,
		5352,
		7295,
		2851,
		7578,
		8838,
		9511
	],
	"./details/common/common.tsx": [
		79511,
		8023,
		7427,
		5352,
		7295,
		2851,
		7578,
		8838,
		9511
	],
	"./details/common/errata": [
		82851,
		7427,
		2851
	],
	"./details/common/errata.tsx": [
		82851,
		7427,
		2851
	],
	"./details/common/featured-resources/featured-resources": [
		92505,
		8308,
		7427,
		3242,
		353,
		8428,
		9089,
		8116,
		2505
	],
	"./details/common/featured-resources/featured-resources.scss": [
		78116,
		8116
	],
	"./details/common/featured-resources/featured-resources.tsx": [
		92505,
		8308,
		7427,
		3242,
		353,
		8428,
		9089,
		8116,
		2505
	],
	"./details/common/get-this-title": [
		55060,
		3925,
		5060
	],
	"./details/common/get-this-title-files/get-this-title.scss": [
		26306,
		3925
	],
	"./details/common/get-this-title-files/give-before-pdf/common-elements": [
		66853
	],
	"./details/common/get-this-title-files/give-before-pdf/common-elements.tsx": [
		66853
	],
	"./details/common/get-this-title-files/give-before-pdf/content-warning": [
		77798
	],
	"./details/common/get-this-title-files/give-before-pdf/content-warning.tsx": [
		77798
	],
	"./details/common/get-this-title-files/give-before-pdf/give-before-other": [
		30854
	],
	"./details/common/get-this-title-files/give-before-pdf/give-before-other.tsx": [
		30854
	],
	"./details/common/get-this-title-files/give-before-pdf/give-before-pdf": [
		25594
	],
	"./details/common/get-this-title-files/give-before-pdf/give-before-pdf.scss": [
		20121
	],
	"./details/common/get-this-title-files/give-before-pdf/give-before-pdf.tsx": [
		25594
	],
	"./details/common/get-this-title-files/give-before-pdf/thank-you-form": [
		76697
	],
	"./details/common/get-this-title-files/give-before-pdf/thank-you-form.scss": [
		75852
	],
	"./details/common/get-this-title-files/give-before-pdf/thank-you-form.tsx": [
		76697
	],
	"./details/common/get-this-title-files/give-before-pdf/use-donation-popup-data": [
		12392
	],
	"./details/common/get-this-title-files/give-before-pdf/use-donation-popup-data.ts": [
		12392
	],
	"./details/common/get-this-title-files/give-before-pdf/use-give-dialog": [
		17092
	],
	"./details/common/get-this-title-files/give-before-pdf/use-give-dialog.tsx": [
		17092
	],
	"./details/common/get-this-title-files/give-before-pdf/use-give-links": [
		95987
	],
	"./details/common/get-this-title-files/give-before-pdf/use-give-links.ts": [
		95987
	],
	"./details/common/get-this-title-files/options": [
		30477
	],
	"./details/common/get-this-title-files/options.tsx": [
		30477
	],
	"./details/common/get-this-title-files/order-print-copy/order-print-copy": [
		70656
	],
	"./details/common/get-this-title-files/order-print-copy/order-print-copy.scss": [
		99287
	],
	"./details/common/get-this-title-files/order-print-copy/order-print-copy.tsx": [
		70656
	],
	"./details/common/get-this-title-files/recommended-callout/recommended-callout": [
		97958
	],
	"./details/common/get-this-title-files/recommended-callout/recommended-callout.scss": [
		63429
	],
	"./details/common/get-this-title-files/recommended-callout/recommended-callout.tsx": [
		97958
	],
	"./details/common/get-this-title-files/recommended-callout/use-callout-counter": [
		55791
	],
	"./details/common/get-this-title-files/recommended-callout/use-callout-counter.ts": [
		55791
	],
	"./details/common/get-this-title.tsx": [
		55060,
		3925,
		5060
	],
	"./details/common/hooks": [
		98113,
		8023,
		7427,
		5352,
		8022,
		8113
	],
	"./details/common/hooks.tsx": [
		98113,
		8023,
		7427,
		5352,
		8022,
		8113
	],
	"./details/common/let-us-know/let-us-know": [
		97987,
		8308,
		4110,
		7987
	],
	"./details/common/let-us-know/let-us-know.scss": [
		14110,
		4110
	],
	"./details/common/let-us-know/let-us-know.tsx": [
		97987,
		8308,
		4110,
		7987
	],
	"./details/common/links-to-translations": [
		96410,
		8308,
		7427,
		2088,
		6410
	],
	"./details/common/links-to-translations.tsx": [
		96410,
		8308,
		7427,
		2088,
		6410
	],
	"./details/common/publication-info": [
		17295,
		8023,
		7427,
		5352,
		7295
	],
	"./details/common/publication-info.tsx": [
		17295,
		8023,
		7427,
		5352,
		7295
	],
	"./details/common/resource-box/left-content": [
		53242,
		8308,
		3242
	],
	"./details/common/resource-box/left-content.tsx": [
		53242,
		8308,
		3242
	],
	"./details/common/resource-box/resource-box": [
		10353,
		8308,
		3242,
		353
	],
	"./details/common/resource-box/resource-box-utils": [
		86045,
		6045
	],
	"./details/common/resource-box/resource-box-utils.tsx": [
		86045,
		6045
	],
	"./details/common/resource-box/resource-box.scss": [
		58428,
		8428
	],
	"./details/common/resource-box/resource-box.tsx": [
		10353,
		8308,
		3242,
		353
	],
	"./details/common/resource-box/resource-boxes": [
		59089,
		8308,
		7427,
		3242,
		353,
		8428,
		9089
	],
	"./details/common/resource-box/resource-boxes.tsx": [
		59089,
		8308,
		7427,
		3242,
		353,
		8428,
		9089
	],
	"./details/common/resource-box/video-resource-box": [
		79611,
		8308,
		3242,
		353,
		9611
	],
	"./details/common/resource-box/video-resource-box.tsx": [
		79611,
		8308,
		3242,
		353,
		9611
	],
	"./details/common/savings-blurb": [
		30167,
		8308,
		7427,
		2030,
		167
	],
	"./details/common/savings-blurb.scss": [
		62030,
		2030
	],
	"./details/common/savings-blurb.tsx": [
		30167,
		8308,
		7427,
		2030,
		167
	],
	"./details/common/tab-utils": [
		65741,
		5741
	],
	"./details/common/tab-utils.ts": [
		65741,
		5741
	],
	"./details/common/toc-slideout/context": [
		45026
	],
	"./details/common/toc-slideout/context.ts": [
		45026
	],
	"./details/common/toc-slideout/toc-slideout": [
		82453,
		2453
	],
	"./details/common/toc-slideout/toc-slideout.tsx": [
		82453,
		2453
	],
	"./details/common/track-link": [
		62958
	],
	"./details/common/track-link.ts": [
		62958
	],
	"./details/context": [
		77427,
		7427
	],
	"./details/context.tsx": [
		77427,
		7427
	],
	"./details/desktop-view/desktop-view": [
		81062,
		8023,
		7427,
		5352,
		7295,
		2851,
		7578,
		8838,
		9511,
		8446,
		5741,
		8115,
		4292,
		6227,
		1062
	],
	"./details/desktop-view/desktop-view.js": [
		81062,
		8023,
		7427,
		5352,
		7295,
		2851,
		7578,
		8838,
		9511,
		8446,
		5741,
		8115,
		4292,
		6227,
		1062
	],
	"./details/desktop-view/desktop-view.scss": [
		4292,
		4292
	],
	"./details/desktop-view/details-tab/details-tab": [
		62209,
		8308,
		8023,
		7427,
		5352,
		7295,
		2851,
		7578,
		8838,
		1097,
		9511,
		3925,
		4110,
		2030,
		7653,
		7987,
		5060,
		167,
		1673,
		2209
	],
	"./details/desktop-view/details-tab/details-tab.js": [
		62209,
		8308,
		8023,
		7427,
		5352,
		7295,
		2851,
		7578,
		8838,
		1097,
		9511,
		3925,
		4110,
		2030,
		7653,
		7987,
		5060,
		167,
		1673,
		2209
	],
	"./details/desktop-view/details-tab/details-tab.scss": [
		11673,
		1673
	],
	"./details/desktop-view/instructor-resource-tab/import-instructor-resource-tab": [
		32721,
		8308,
		8023,
		7427,
		5352,
		3242,
		353,
		8428,
		9089,
		6045,
		8022,
		7553,
		8113,
		8116,
		1097,
		9611,
		2505,
		7653,
		2206,
		2853,
		5570,
		7086,
		2721
	],
	"./details/desktop-view/instructor-resource-tab/import-instructor-resource-tab.js": [
		32721,
		8308,
		8023,
		7427,
		5352,
		3242,
		353,
		8428,
		9089,
		6045,
		8022,
		7553,
		8113,
		8116,
		1097,
		9611,
		2505,
		7653,
		2206,
		2853,
		5570,
		7086,
		2721
	],
	"./details/desktop-view/instructor-resource-tab/instructor-resource-tab": [
		37086,
		8308,
		8023,
		7427,
		5352,
		3242,
		353,
		8428,
		9089,
		6045,
		8022,
		7553,
		8113,
		8116,
		1097,
		9611,
		2505,
		7653,
		2206,
		2853,
		5570,
		7086
	],
	"./details/desktop-view/instructor-resource-tab/instructor-resource-tab.scss": [
		52853,
		2853
	],
	"./details/desktop-view/instructor-resource-tab/instructor-resource-tab.tsx": [
		37086,
		8308,
		8023,
		7427,
		5352,
		3242,
		353,
		8428,
		9089,
		6045,
		8022,
		7553,
		8113,
		8116,
		1097,
		9611,
		2505,
		7653,
		2206,
		2853,
		5570,
		7086
	],
	"./details/desktop-view/instructor-resource-tab/partners/partners": [
		75570,
		8308,
		7553,
		2206,
		5570
	],
	"./details/desktop-view/instructor-resource-tab/partners/partners.js": [
		75570,
		8308,
		7553,
		2206,
		5570
	],
	"./details/desktop-view/instructor-resource-tab/partners/partners.scss": [
		72206,
		2206
	],
	"./details/desktop-view/promo": [
		50034,
		1097,
		7653
	],
	"./details/desktop-view/promo.scss": [
		61097,
		1097
	],
	"./details/desktop-view/promo.tsx": [
		50034,
		1097,
		7653
	],
	"./details/desktop-view/student-resource-tab/import-student-resource-tab": [
		7163,
		8308,
		7427,
		3242,
		353,
		8428,
		9089,
		6045,
		9411,
		6852,
		7163
	],
	"./details/desktop-view/student-resource-tab/import-student-resource-tab.js": [
		7163,
		8308,
		7427,
		3242,
		353,
		8428,
		9089,
		6045,
		9411,
		6852,
		7163
	],
	"./details/desktop-view/student-resource-tab/student-resource-tab": [
		36852,
		8308,
		7427,
		3242,
		353,
		8428,
		9089,
		6045,
		9411,
		6852
	],
	"./details/desktop-view/student-resource-tab/student-resource-tab.scss": [
		9411,
		9411
	],
	"./details/desktop-view/student-resource-tab/student-resource-tab.tsx": [
		36852,
		8308,
		7427,
		3242,
		353,
		8428,
		9089,
		6045,
		9411,
		6852
	],
	"./details/desktop-view/videos-tab/videos-tab": [
		26227,
		8115,
		6227
	],
	"./details/desktop-view/videos-tab/videos-tab.js": [
		26227,
		8115,
		6227
	],
	"./details/desktop-view/videos-tab/videos-tab.scss": [
		58115,
		8115
	],
	"./details/details": [
		28104,
		8308,
		8023,
		1261,
		7427,
		5352,
		2088,
		8022,
		8113,
		6410,
		1263,
		2782,
		6166,
		2453,
		7796,
		8104
	],
	"./details/details.scss": [
		91263,
		1263
	],
	"./details/details.tsx": [
		28104,
		8308,
		8023,
		1261,
		7427,
		5352,
		2088,
		8022,
		8113,
		6410,
		1263,
		2782,
		6166,
		2453,
		7796,
		8104
	],
	"./details/dual-view": [
		6166,
		8308,
		1261,
		7427,
		2088,
		6410,
		6166
	],
	"./details/dual-view.tsx": [
		6166,
		8308,
		1261,
		7427,
		2088,
		6410,
		6166
	],
	"./details/phone-view/details-pane/details-pane": [
		2122,
		8308,
		8023,
		7427,
		5352,
		7295,
		2851,
		7578,
		8838,
		9511,
		2030,
		167,
		4189,
		2122
	],
	"./details/phone-view/details-pane/details-pane.js": [
		2122,
		8308,
		8023,
		7427,
		5352,
		7295,
		2851,
		7578,
		8838,
		9511,
		2030,
		167,
		4189,
		2122
	],
	"./details/phone-view/details-pane/details-pane.scss": [
		74189,
		4189
	],
	"./details/phone-view/instructor-resources-pane/instructor-resources-pane": [
		2637,
		8308,
		1261,
		7427,
		3242,
		353,
		8428,
		9089,
		6045,
		8116,
		9611,
		2505,
		1309,
		2637
	],
	"./details/phone-view/instructor-resources-pane/instructor-resources-pane.js": [
		2637,
		8308,
		1261,
		7427,
		3242,
		353,
		8428,
		9089,
		6045,
		8116,
		9611,
		2505,
		1309,
		2637
	],
	"./details/phone-view/instructor-resources-pane/instructor-resources-pane.scss": [
		1309,
		1309
	],
	"./details/phone-view/phone-view": [
		73322,
		8308,
		8023,
		7427,
		5352,
		8022,
		7295,
		2851,
		7578,
		8838,
		8113,
		9511,
		3925,
		4110,
		7987,
		5060,
		5741,
		2996,
		3322
	],
	"./details/phone-view/phone-view.js": [
		73322,
		8308,
		8023,
		7427,
		5352,
		8022,
		7295,
		2851,
		7578,
		8838,
		8113,
		9511,
		3925,
		4110,
		7987,
		5060,
		5741,
		2996,
		3322
	],
	"./details/phone-view/phone-view.scss": [
		72996,
		2996
	],
	"./details/phone-view/student-resources-pane/student-resources-pane": [
		45403,
		8308,
		7427,
		3242,
		353,
		8428,
		9089,
		6045,
		6743,
		5403
	],
	"./details/phone-view/student-resources-pane/student-resources-pane.js": [
		45403,
		8308,
		7427,
		3242,
		353,
		8428,
		9089,
		6045,
		6743,
		5403
	],
	"./details/phone-view/student-resources-pane/student-resources-pane.scss": [
		46743,
		6743
	],
	"./details/table-of-contents.scss": [
		32782,
		2782
	],
	"./details/title-image": [
		7796,
		7427,
		7796
	],
	"./details/title-image.tsx": [
		7796,
		7427,
		7796
	],
	"./errata-detail/detail/detail": [
		79406,
		8857,
		3949,
		9406
	],
	"./errata-detail/detail/detail.scss": [
		43949,
		3949
	],
	"./errata-detail/detail/detail.tsx": [
		79406,
		8857,
		3949,
		9406
	],
	"./errata-detail/errata-detail": [
		92428,
		8857,
		7633,
		3949,
		2579,
		9406,
		6306,
		2428
	],
	"./errata-detail/errata-detail.scss": [
		62579,
		2579
	],
	"./errata-detail/errata-detail.tsx": [
		92428,
		8857,
		7633,
		3949,
		2579,
		9406,
		6306,
		2428
	],
	"./errata-detail/progress-bar/progress-bar": [
		6306,
		7633,
		6306
	],
	"./errata-detail/progress-bar/progress-bar.scss": [
		97633,
		7633
	],
	"./errata-detail/progress-bar/progress-bar.tsx": [
		6306,
		7633,
		6306
	],
	"./errata-form/errata-form": [
		34641,
		8023,
		5352,
		2236,
		7094,
		4583,
		8824,
		6957,
		2960,
		2582,
		7049,
		4153,
		8174,
		9251,
		4641
	],
	"./errata-form/errata-form-context": [
		4583,
		4583
	],
	"./errata-form/errata-form-context.js": [
		4583,
		4583
	],
	"./errata-form/errata-form.js": [
		34641,
		8023,
		5352,
		2236,
		7094,
		4583,
		8824,
		6957,
		2960,
		2582,
		7049,
		4153,
		8174,
		9251,
		4641
	],
	"./errata-form/errata-form.scss": [
		19251,
		9251
	],
	"./errata-form/form/ErrorLocationSelector/ErrorLocationSelector": [
		24153,
		8023,
		5352,
		7094,
		4583,
		8824,
		6957,
		4153
	],
	"./errata-form/form/ErrorLocationSelector/ErrorLocationSelector.js": [
		24153,
		8023,
		5352,
		7094,
		4583,
		8824,
		6957,
		4153
	],
	"./errata-form/form/ErrorLocationSelector/ErrorLocationSelector.scss": [
		26957,
		6957
	],
	"./errata-form/form/ErrorLocationSelector/test-data": [
		99714,
		9714
	],
	"./errata-form/form/ErrorLocationSelector/test-data.js": [
		99714,
		9714
	],
	"./errata-form/form/ErrorLocationSelector/toc-selector": [
		28824,
		8023,
		5352,
		7094,
		4583,
		8824
	],
	"./errata-form/form/ErrorLocationSelector/toc-selector.js": [
		28824,
		8023,
		5352,
		7094,
		4583,
		8824
	],
	"./errata-form/form/ErrorSourceSelector": [
		82582,
		7094,
		4583,
		2582
	],
	"./errata-form/form/ErrorSourceSelector.js": [
		82582,
		7094,
		4583,
		2582
	],
	"./errata-form/form/ErrorTypeSelector": [
		37049,
		7094,
		7049
	],
	"./errata-form/form/ErrorTypeSelector.js": [
		37049,
		7094,
		7049
	],
	"./errata-form/form/FileUploader": [
		2236,
		2236
	],
	"./errata-form/form/FileUploader.js": [
		2236,
		2236
	],
	"./errata-form/form/FileUploader.scss": [
		95718,
		5718
	],
	"./errata-form/form/InvalidMessage": [
		77094,
		7094
	],
	"./errata-form/form/InvalidMessage.js": [
		77094,
		7094
	],
	"./errata-form/form/form": [
		88174,
		8023,
		5352,
		2236,
		7094,
		4583,
		8824,
		6957,
		2960,
		2582,
		7049,
		4153,
		8174
	],
	"./errata-form/form/form.js": [
		88174,
		8023,
		5352,
		2236,
		7094,
		4583,
		8824,
		6957,
		2960,
		2582,
		7049,
		4153,
		8174
	],
	"./errata-form/form/form.scss": [
		42960,
		2960
	],
	"./errata-summary/errata-summary": [
		55891,
		8308,
		8857,
		4570,
		7928,
		8858,
		9616,
		4346,
		493,
		5891
	],
	"./errata-summary/errata-summary.js": [
		55891,
		8308,
		8857,
		4570,
		7928,
		8858,
		9616,
		4346,
		493,
		5891
	],
	"./errata-summary/errata-summary.scss": [
		10493,
		493
	],
	"./errata-summary/hero/hero": [
		4346,
		8308,
		8858,
		4346
	],
	"./errata-summary/hero/hero.js": [
		4346,
		8308,
		8858,
		4346
	],
	"./errata-summary/hero/hero.scss": [
		18858,
		8858
	],
	"./errata-summary/table/table": [
		59616,
		8857,
		7928,
		9616
	],
	"./errata-summary/table/table.js": [
		59616,
		8857,
		7928,
		9616
	],
	"./errata-summary/table/table.scss": [
		47928,
		7928
	],
	"./faq/faq": [
		10064,
		5943,
		64
	],
	"./faq/faq.scss": [
		55943,
		5943
	],
	"./faq/faq.tsx": [
		10064,
		5943,
		64
	],
	"./flex-page/blocks/BookListBlock": [
		43642
	],
	"./flex-page/blocks/BookListBlock.scss": [
		91625
	],
	"./flex-page/blocks/BookListBlock.tsx": [
		43642
	],
	"./flex-page/blocks/CTABlock": [
		29475
	],
	"./flex-page/blocks/CTABlock.scss": [
		56206
	],
	"./flex-page/blocks/CTABlock.tsx": [
		29475
	],
	"./flex-page/blocks/CardsBlock": [
		91890
	],
	"./flex-page/blocks/CardsBlock.scss": [
		56193
	],
	"./flex-page/blocks/CardsBlock.tsx": [
		91890
	],
	"./flex-page/blocks/ContentBlock": [
		8180
	],
	"./flex-page/blocks/ContentBlock.tsx": [
		8180
	],
	"./flex-page/blocks/DividerBlock": [
		44744
	],
	"./flex-page/blocks/DividerBlock.scss": [
		12375
	],
	"./flex-page/blocks/DividerBlock.tsx": [
		44744
	],
	"./flex-page/blocks/FAQBlock": [
		23813
	],
	"./flex-page/blocks/FAQBlock.scss": [
		2336
	],
	"./flex-page/blocks/FAQBlock.tsx": [
		23813
	],
	"./flex-page/blocks/HTMLBlock": [
		77566
	],
	"./flex-page/blocks/HTMLBlock.tsx": [
		77566
	],
	"./flex-page/blocks/HeroBlock": [
		87979
	],
	"./flex-page/blocks/HeroBlock.scss": [
		95398
	],
	"./flex-page/blocks/HeroBlock.tsx": [
		87979
	],
	"./flex-page/blocks/LinksBlock": [
		6972
	],
	"./flex-page/blocks/LinksBlock.scss": [
		42523
	],
	"./flex-page/blocks/LinksBlock.tsx": [
		6972
	],
	"./flex-page/blocks/QuoteBlock": [
		38105
	],
	"./flex-page/blocks/QuoteBlock.scss": [
		33212
	],
	"./flex-page/blocks/QuoteBlock.tsx": [
		38105
	],
	"./flex-page/blocks/RichTextBlock": [
		73766
	],
	"./flex-page/blocks/RichTextBlock.scss": [
		65069
	],
	"./flex-page/blocks/RichTextBlock.tsx": [
		73766
	],
	"./flex-page/blocks/SectionBlock": [
		88054
	],
	"./flex-page/blocks/SectionBlock.scss": [
		15309
	],
	"./flex-page/blocks/SectionBlock.tsx": [
		88054
	],
	"./flex-page/components/Image": [
		24589
	],
	"./flex-page/components/Image.tsx": [
		24589
	],
	"./flex-page/components/Link": [
		53348
	],
	"./flex-page/components/Link.tsx": [
		53348
	],
	"./flex-page/flex-page": [
		55196
	],
	"./flex-page/flex-page.scss": [
		26467
	],
	"./flex-page/flex-page.tsx": [
		55196
	],
	"./flex-page/utils": [
		99788
	],
	"./flex-page/utils.ts": [
		99788
	],
	"./footer-page/footer-page": [
		17016,
		4447,
		7016
	],
	"./footer-page/footer-page.scss": [
		24447,
		4447
	],
	"./footer-page/footer-page.tsx": [
		17016,
		4447,
		7016
	],
	"./foundation/foundation": [
		85865,
		2480,
		8507,
		5865
	],
	"./foundation/foundation.js": [
		85865,
		2480,
		8507,
		5865
	],
	"./foundation/foundation.scss": [
		98507,
		8507
	],
	"./general/general": [
		76848
	],
	"./general/general.scss": [
		63927
	],
	"./general/general.tsx": [
		76848
	],
	"./global-reach/global-reach": [
		87140,
		8308,
		6049,
		437,
		2280,
		285,
		6914,
		6142,
		789,
		5830,
		7140
	],
	"./global-reach/global-reach.tsx": [
		87140,
		8308,
		6049,
		437,
		2280,
		285,
		6914,
		6142,
		789,
		5830,
		7140
	],
	"./global-reach/map/map": [
		5830,
		437,
		5830
	],
	"./global-reach/map/map.scss": [
		437,
		437
	],
	"./global-reach/map/map.tsx": [
		5830,
		437,
		5830
	],
	"./global-reach/schoolmap/schoolmap": [
		76142,
		8308,
		285,
		6142
	],
	"./global-reach/schoolmap/schoolmap.scss": [
		10285,
		285
	],
	"./global-reach/schoolmap/schoolmap.tsx": [
		76142,
		8308,
		285,
		6142
	],
	"./global-reach/statistics/stat": [
		50789,
		2280,
		789
	],
	"./global-reach/statistics/stat.scss": [
		2280,
		2280
	],
	"./global-reach/statistics/stat.tsx": [
		50789,
		2280,
		789
	],
	"./global-reach/studentinfo/studentinfo": [
		46914,
		6049,
		6914
	],
	"./global-reach/studentinfo/studentinfo.scss": [
		96049,
		6049
	],
	"./global-reach/studentinfo/studentinfo.tsx": [
		46914,
		6049,
		6914
	],
	"./impact/disruption": [
		52755,
		5654,
		2755
	],
	"./impact/disruption.scss": [
		95654,
		5654
	],
	"./impact/disruption.tsx": [
		52755,
		5654,
		2755
	],
	"./impact/four-square": [
		53134,
		8308,
		1261,
		5282,
		2480,
		5628,
		9221,
		3134
	],
	"./impact/four-square.scss": [
		49221,
		9221
	],
	"./impact/four-square.tsx": [
		53134,
		8308,
		1261,
		5282,
		2480,
		5628,
		9221,
		3134
	],
	"./impact/give": [
		20331,
		542,
		331
	],
	"./impact/give.scss": [
		542,
		542
	],
	"./impact/give.tsx": [
		20331,
		542,
		331
	],
	"./impact/impact": [
		29350,
		8308,
		7201,
		6516,
		484,
		9593,
		1261,
		5282,
		2480,
		9309,
		7512,
		951,
		240,
		8489,
		4347,
		5628,
		542,
		2501,
		9221,
		5654,
		6421,
		7980,
		3134,
		9774,
		331,
		2755,
		9350
	],
	"./impact/impact.scss": [
		6421,
		6421
	],
	"./impact/impact.tsx": [
		29350,
		8308,
		7201,
		6516,
		484,
		9593,
		1261,
		5282,
		2480,
		9309,
		7512,
		951,
		240,
		8489,
		4347,
		5628,
		542,
		2501,
		9221,
		5654,
		6421,
		7980,
		3134,
		9774,
		331,
		2755,
		9350
	],
	"./impact/quote": [
		19774,
		2501,
		9774
	],
	"./impact/quote.scss": [
		72501,
		2501
	],
	"./impact/quote.tsx": [
		19774,
		2501,
		9774
	],
	"./impact/testimonials": [
		7980,
		8308,
		7201,
		6516,
		9593,
		1261,
		5282,
		2480,
		9309,
		7512,
		951,
		240,
		8489,
		4347,
		7980
	],
	"./impact/testimonials.scss": [
		84347,
		4347
	],
	"./impact/testimonials.tsx": [
		7980,
		8308,
		7201,
		6516,
		9593,
		1261,
		5282,
		2480,
		9309,
		7512,
		951,
		240,
		8489,
		4347,
		7980
	],
	"./institutional-partnership-application/institutional-partnership-application": [
		7077,
		8023,
		559,
		7077
	],
	"./institutional-partnership-application/institutional-partnership-application.js": [
		7077,
		8023,
		559,
		7077
	],
	"./institutional-partnership-application/institutional-partnership-application.scss": [
		10559,
		559
	],
	"./institutional-partnership/institutional-partnership": [
		60841,
		8308,
		8023,
		484,
		5605,
		5836,
		5279,
		2731,
		7263,
		2703,
		2293,
		9075,
		41,
		4763,
		2661,
		4615,
		1202,
		779,
		1069,
		5775,
		8443,
		3135,
		3985,
		1589,
		3387,
		351,
		5383,
		3411,
		841
	],
	"./institutional-partnership/institutional-partnership.js": [
		60841,
		8308,
		8023,
		484,
		5605,
		5836,
		5279,
		2731,
		7263,
		2703,
		2293,
		9075,
		41,
		4763,
		2661,
		4615,
		1202,
		779,
		1069,
		5775,
		8443,
		3135,
		3985,
		1589,
		3387,
		351,
		5383,
		3411,
		841
	],
	"./institutional-partnership/institutional-partnership.scss": [
		70779,
		779
	],
	"./institutional-partnership/sections/about/about": [
		5383,
		5605,
		4615,
		5383
	],
	"./institutional-partnership/sections/about/about.js": [
		5383,
		5605,
		4615,
		5383
	],
	"./institutional-partnership/sections/about/about.scss": [
		14615,
		4615
	],
	"./institutional-partnership/sections/banner/banner": [
		33985,
		5605,
		41,
		3985
	],
	"./institutional-partnership/sections/banner/banner.js": [
		33985,
		5605,
		41,
		3985
	],
	"./institutional-partnership/sections/banner/banner.scss": [
		50041,
		41
	],
	"./institutional-partnership/sections/big-quote/big-quote": [
		23135,
		5605,
		5279,
		3135
	],
	"./institutional-partnership/sections/big-quote/big-quote.js": [
		23135,
		5605,
		5279,
		3135
	],
	"./institutional-partnership/sections/big-quote/big-quote.scss": [
		85279,
		5279
	],
	"./institutional-partnership/sections/overlapping-quote/overlapping-quote": [
		60351,
		2703,
		351
	],
	"./institutional-partnership/sections/overlapping-quote/overlapping-quote.js": [
		60351,
		2703,
		351
	],
	"./institutional-partnership/sections/overlapping-quote/overlapping-quote.scss": [
		52703,
		2703
	],
	"./institutional-partnership/sections/participants/established-partners/established-partners": [
		61202,
		5836,
		1202
	],
	"./institutional-partnership/sections/participants/established-partners/established-partners.js": [
		61202,
		5836,
		1202
	],
	"./institutional-partnership/sections/participants/established-partners/established-partners.scss": [
		95836,
		5836
	],
	"./institutional-partnership/sections/participants/participants": [
		41069,
		8308,
		8023,
		5836,
		2661,
		1202,
		1069
	],
	"./institutional-partnership/sections/participants/participants.js": [
		41069,
		8308,
		8023,
		5836,
		2661,
		1202,
		1069
	],
	"./institutional-partnership/sections/participants/participants.scss": [
		42661,
		2661
	],
	"./institutional-partnership/sections/promoting/promoting": [
		5775,
		7263,
		5775
	],
	"./institutional-partnership/sections/promoting/promoting.js": [
		5775,
		7263,
		5775
	],
	"./institutional-partnership/sections/promoting/promoting.scss": [
		77263,
		7263
	],
	"./institutional-partnership/sections/results/results": [
		48443,
		9075,
		8443
	],
	"./institutional-partnership/sections/results/results.js": [
		48443,
		9075,
		8443
	],
	"./institutional-partnership/sections/results/results.scss": [
		59075,
		9075
	],
	"./institutional-partnership/sections/sign-up/sign-up": [
		3387,
		8308,
		2731,
		3387
	],
	"./institutional-partnership/sections/sign-up/sign-up.js": [
		3387,
		8308,
		2731,
		3387
	],
	"./institutional-partnership/sections/sign-up/sign-up.scss": [
		52731,
		2731
	],
	"./institutional-partnership/sections/small-quote/small-quote": [
		3411,
		4763,
		3411
	],
	"./institutional-partnership/sections/small-quote/small-quote.js": [
		3411,
		4763,
		3411
	],
	"./institutional-partnership/sections/small-quote/small-quote.scss": [
		14763,
		4763
	],
	"./institutional-partnership/sections/speaking/speaking": [
		81589,
		2293,
		1589
	],
	"./institutional-partnership/sections/speaking/speaking.js": [
		81589,
		2293,
		1589
	],
	"./institutional-partnership/sections/speaking/speaking.scss": [
		12293,
		2293
	],
	"./interest/interest": [
		32793,
		8308,
		5848,
		6452,
		9178,
		670,
		5377,
		8050,
		588,
		9145,
		2793
	],
	"./interest/interest.scss": [
		69145,
		9145
	],
	"./interest/interest.tsx": [
		32793,
		8308,
		5848,
		6452,
		9178,
		670,
		5377,
		8050,
		588,
		9145,
		2793
	],
	"./k12/import-k12-main": [
		76167,
		8308,
		8023,
		484,
		1261,
		5605,
		5848,
		6452,
		9178,
		670,
		5377,
		8050,
		588,
		9145,
		9238,
		2793,
		3361,
		7495,
		6554,
		3558,
		91,
		6388,
		7266,
		4570,
		8192,
		3370,
		807,
		5572,
		2787,
		5804,
		6167
	],
	"./k12/import-k12-main.js": [
		76167,
		8308,
		8023,
		484,
		1261,
		5605,
		5848,
		6452,
		9178,
		670,
		5377,
		8050,
		588,
		9145,
		9238,
		2793,
		3361,
		7495,
		6554,
		3558,
		91,
		6388,
		7266,
		4570,
		8192,
		3370,
		807,
		5572,
		2787,
		5804,
		6167
	],
	"./k12/import-subject": [
		57971,
		8308,
		2872,
		5033,
		9984,
		7541,
		5605,
		5848,
		6452,
		9178,
		670,
		5377,
		8050,
		588,
		6129,
		9145,
		9238,
		2793,
		5254,
		7028,
		8227,
		9466,
		9112,
		9756,
		7526,
		8105,
		9997,
		303,
		707,
		7971
	],
	"./k12/import-subject.js": [
		57971,
		8308,
		2872,
		5033,
		9984,
		7541,
		5605,
		5848,
		6452,
		9178,
		670,
		5377,
		8050,
		588,
		6129,
		9145,
		9238,
		2793,
		5254,
		7028,
		8227,
		9466,
		9112,
		9756,
		7526,
		8105,
		9997,
		303,
		707,
		7971
	],
	"./k12/k12": [
		92952,
		2952
	],
	"./k12/k12-main/banner": [
		32787,
		5605,
		3558,
		2787
	],
	"./k12/k12-main/banner.scss": [
		13558,
		3558
	],
	"./k12/k12-main/banner.tsx": [
		32787,
		5605,
		3558,
		2787
	],
	"./k12/k12-main/faq": [
		38505,
		9238,
		6388,
		8505
	],
	"./k12/k12-main/faq.scss": [
		26388,
		6388
	],
	"./k12/k12-main/faq.tsx": [
		38505,
		9238,
		6388,
		8505
	],
	"./k12/k12-main/features": [
		25804,
		91,
		5804
	],
	"./k12/k12-main/features.scss": [
		20091,
		91
	],
	"./k12/k12-main/features.tsx": [
		25804,
		91,
		5804
	],
	"./k12/k12-main/k12-main": [
		34561,
		8308,
		8023,
		484,
		1261,
		5605,
		5848,
		6452,
		9178,
		670,
		5377,
		8050,
		588,
		9145,
		9238,
		2793,
		3361,
		7495,
		6554,
		3558,
		91,
		6388,
		7266,
		4570,
		8192,
		3370,
		807,
		5572,
		2787,
		5804,
		4561
	],
	"./k12/k12-main/k12-main.scss": [
		5572,
		5572
	],
	"./k12/k12-main/k12-main.tsx": [
		34561,
		8308,
		8023,
		484,
		1261,
		5605,
		5848,
		6452,
		9178,
		670,
		5377,
		8050,
		588,
		9145,
		9238,
		2793,
		3361,
		7495,
		6554,
		3558,
		91,
		6388,
		7266,
		4570,
		8192,
		3370,
		807,
		5572,
		2787,
		5804,
		4561
	],
	"./k12/k12-main/sign-up-form": [
		60679,
		8308,
		5848,
		6452,
		9178,
		670,
		5377,
		8050,
		588,
		9145,
		2793,
		7266,
		679
	],
	"./k12/k12-main/sign-up-form.scss": [
		27266,
		7266
	],
	"./k12/k12-main/sign-up-form.tsx": [
		60679,
		8308,
		5848,
		6452,
		9178,
		670,
		5377,
		8050,
		588,
		9145,
		2793,
		7266,
		679
	],
	"./k12/k12-main/stats-grid": [
		20807,
		8308,
		5605,
		6554,
		807
	],
	"./k12/k12-main/stats-grid.scss": [
		26554,
		6554
	],
	"./k12/k12-main/stats-grid.tsx": [
		20807,
		8308,
		5605,
		6554,
		807
	],
	"./k12/k12-main/subjects": [
		83370,
		8308,
		8023,
		5605,
		3361,
		4570,
		3370
	],
	"./k12/k12-main/subjects.scss": [
		93361,
		3361
	],
	"./k12/k12-main/subjects.tsx": [
		83370,
		8308,
		8023,
		5605,
		3361,
		4570,
		3370
	],
	"./k12/k12-main/testimonial": [
		58192,
		1261,
		7495,
		8192
	],
	"./k12/k12-main/testimonial.scss": [
		7495,
		7495
	],
	"./k12/k12-main/testimonial.tsx": [
		58192,
		1261,
		7495,
		8192
	],
	"./k12/k12.tsx": [
		92952,
		2952
	],
	"./k12/subject/banner": [
		89997,
		5605,
		9112,
		9997
	],
	"./k12/subject/banner.scss": [
		79112,
		9112
	],
	"./k12/subject/banner.tsx": [
		89997,
		5605,
		9112,
		9997
	],
	"./k12/subject/books": [
		18105,
		9238,
		5254,
		7028,
		8105
	],
	"./k12/subject/books.scss": [
		17028,
		7028
	],
	"./k12/subject/books.tsx": [
		18105,
		9238,
		5254,
		7028,
		8105
	],
	"./k12/subject/contact": [
		30303,
		8308,
		5848,
		6452,
		9178,
		670,
		5377,
		8050,
		588,
		9145,
		2793,
		9466,
		303
	],
	"./k12/subject/contact.scss": [
		39466,
		9466
	],
	"./k12/subject/contact.tsx": [
		30303,
		8308,
		5848,
		6452,
		9178,
		670,
		5377,
		8050,
		588,
		9145,
		2793,
		9466,
		303
	],
	"./k12/subject/resources": [
		59756,
		2872,
		5033,
		9984,
		7541,
		6129,
		8227,
		9756
	],
	"./k12/subject/resources.scss": [
		28227,
		8227
	],
	"./k12/subject/resources.tsx": [
		59756,
		2872,
		5033,
		9984,
		7541,
		6129,
		8227,
		9756
	],
	"./k12/subject/subject": [
		90707,
		8308,
		2872,
		5033,
		9984,
		7541,
		5605,
		5848,
		6452,
		9178,
		670,
		5377,
		8050,
		588,
		6129,
		9145,
		9238,
		2793,
		5254,
		7028,
		8227,
		9466,
		9112,
		9756,
		7526,
		8105,
		9997,
		303,
		707
	],
	"./k12/subject/subject.scss": [
		77526,
		7526
	],
	"./k12/subject/subject.tsx": [
		90707,
		8308,
		2872,
		5033,
		9984,
		7541,
		5605,
		5848,
		6452,
		9178,
		670,
		5377,
		8050,
		588,
		6129,
		9145,
		9238,
		2793,
		5254,
		7028,
		8227,
		9466,
		9112,
		9756,
		7526,
		8105,
		9997,
		303,
		707
	],
	"./partners/active-filters/active-filters": [
		22506,
		6981,
		4465,
		5697,
		2506
	],
	"./partners/active-filters/active-filters.scss": [
		54465,
		4465
	],
	"./partners/active-filters/active-filters.tsx": [
		22506,
		6981,
		4465,
		5697,
		2506
	],
	"./partners/active-filters/filter-remover": [
		35697,
		5697
	],
	"./partners/active-filters/filter-remover.tsx": [
		35697,
		5697
	],
	"./partners/controls/advanced-options/advanced-options": [
		4639,
		8308,
		8023,
		3189,
		4279,
		4639
	],
	"./partners/controls/advanced-options/advanced-options.tsx": [
		4639,
		8308,
		8023,
		3189,
		4279,
		4639
	],
	"./partners/controls/book-options/book-options": [
		93826,
		8308,
		5848,
		3189,
		4279,
		6512,
		3826
	],
	"./partners/controls/book-options/book-options.scss": [
		76512,
		6512
	],
	"./partners/controls/book-options/book-options.tsx": [
		93826,
		8308,
		5848,
		3189,
		4279,
		6512,
		3826
	],
	"./partners/controls/button-with-popover.scss": [
		23598,
		3598
	],
	"./partners/controls/checkboxes-linked-to-store/checkboxes-linked-to-store": [
		74279,
		8308,
		3189,
		4279
	],
	"./partners/controls/checkboxes-linked-to-store/checkboxes-linked-to-store.scss": [
		85570,
		3189
	],
	"./partners/controls/checkboxes-linked-to-store/checkboxes-linked-to-store.tsx": [
		74279,
		8308,
		3189,
		4279
	],
	"./partners/controls/controls": [
		41678,
		8308,
		8023,
		5848,
		6981,
		3189,
		4279,
		6512,
		6418,
		1573,
		3598,
		3826,
		4639,
		1319,
		1678
	],
	"./partners/controls/controls.scss": [
		11573,
		1573
	],
	"./partners/controls/controls.tsx": [
		41678,
		8308,
		8023,
		5848,
		6981,
		3189,
		4279,
		6512,
		6418,
		1573,
		3598,
		3826,
		4639,
		1319,
		1678
	],
	"./partners/controls/options-list/options-list": [
		41319,
		6418,
		1319
	],
	"./partners/controls/options-list/options-list.scss": [
		96418,
		6418
	],
	"./partners/controls/options-list/options-list.tsx": [
		41319,
		6418,
		1319
	],
	"./partners/mobile-controls/mobile-controls": [
		54320,
		8308,
		8023,
		1261,
		5848,
		6981,
		3620,
		3189,
		4279,
		6512,
		6418,
		1573,
		3598,
		4465,
		3826,
		4639,
		1319,
		5697,
		8703,
		1678,
		2506,
		4320
	],
	"./partners/mobile-controls/mobile-controls.scss": [
		8703,
		8703
	],
	"./partners/mobile-controls/mobile-controls.tsx": [
		54320,
		8308,
		8023,
		1261,
		5848,
		6981,
		3620,
		3189,
		4279,
		6512,
		6418,
		1573,
		3598,
		4465,
		3826,
		4639,
		1319,
		5697,
		8703,
		1678,
		2506,
		4320
	],
	"./partners/partner-details/carousel/carousel": [
		43328,
		8308,
		7201,
		6516,
		9309,
		7895,
		3328
	],
	"./partners/partner-details/carousel/carousel.scss": [
		87895,
		7895
	],
	"./partners/partner-details/carousel/carousel.tsx": [
		43328,
		8308,
		7201,
		6516,
		9309,
		7895,
		3328
	],
	"./partners/partner-details/info-request-form/info-request-form": [
		97926,
		5848,
		6452,
		9178,
		670,
		6981,
		3620,
		5460,
		1363,
		8293,
		622,
		7926
	],
	"./partners/partner-details/info-request-form/info-request-form.scss": [
		18293,
		8293
	],
	"./partners/partner-details/info-request-form/info-request-form.tsx": [
		97926,
		5848,
		6452,
		9178,
		670,
		6981,
		3620,
		5460,
		1363,
		8293,
		622,
		7926
	],
	"./partners/partner-details/info-request-form/school-selector": [
		31363,
		1363
	],
	"./partners/partner-details/info-request-form/school-selector.js": [
		31363,
		1363
	],
	"./partners/partner-details/partner-context": [
		70622,
		622
	],
	"./partners/partner-details/partner-context.ts": [
		70622,
		622
	],
	"./partners/partner-details/partner-details": [
		50264,
		8308,
		7201,
		6516,
		9309,
		5848,
		6452,
		9178,
		670,
		6981,
		3620,
		5460,
		8446,
		8355,
		1363,
		8293,
		7895,
		622,
		7926,
		2615,
		3388,
		3328,
		264
	],
	"./partners/partner-details/partner-details.scss": [
		22615,
		2615
	],
	"./partners/partner-details/partner-details.tsx": [
		50264,
		8308,
		7201,
		6516,
		9309,
		5848,
		6452,
		9178,
		670,
		6981,
		3620,
		5460,
		8446,
		8355,
		1363,
		8293,
		7895,
		622,
		7926,
		2615,
		3388,
		3328,
		264
	],
	"./partners/partner-details/synopsis/synopsis": [
		93388,
		8308,
		8355,
		3388
	],
	"./partners/partner-details/synopsis/synopsis.scss": [
		28355,
		8355
	],
	"./partners/partner-details/synopsis/synopsis.tsx": [
		93388,
		8308,
		8355,
		3388
	],
	"./partners/partners": [
		76908,
		8308,
		8023,
		7201,
		6516,
		6732,
		1261,
		9309,
		5848,
		6452,
		9178,
		670,
		6981,
		8022,
		3620,
		7553,
		3189,
		5460,
		8446,
		8355,
		1363,
		8293,
		7895,
		622,
		4279,
		7926,
		2615,
		6512,
		6418,
		3388,
		6908
	],
	"./partners/partners.scss": [
		31651,
		1651
	],
	"./partners/partners.tsx": [
		76908,
		8308,
		8023,
		7201,
		6516,
		6732,
		1261,
		9309,
		5848,
		6452,
		9178,
		670,
		6981,
		8022,
		3620,
		7553,
		3189,
		5460,
		8446,
		8355,
		1363,
		8293,
		7895,
		622,
		4279,
		7926,
		2615,
		6512,
		6418,
		3388,
		6908
	],
	"./partners/results/result-grid": [
		35938,
		8308,
		7553,
		5938
	],
	"./partners/results/result-grid.tsx": [
		35938,
		8308,
		7553,
		5938
	],
	"./partners/results/results": [
		72004,
		8308,
		8023,
		7201,
		6516,
		6732,
		9309,
		5848,
		6452,
		9178,
		670,
		6981,
		8022,
		3620,
		7553,
		5460,
		8446,
		8355,
		1363,
		8293,
		7895,
		622,
		7926,
		2615,
		3388,
		3328,
		264,
		8723,
		7341,
		5938,
		2004
	],
	"./partners/results/results.scss": [
		38723,
		8723
	],
	"./partners/results/results.tsx": [
		72004,
		8308,
		8023,
		7201,
		6516,
		6732,
		9309,
		5848,
		6452,
		9178,
		670,
		6981,
		8022,
		3620,
		7553,
		5460,
		8446,
		8355,
		1363,
		8293,
		7895,
		622,
		7926,
		2615,
		3388,
		3328,
		264,
		8723,
		7341,
		5938,
		2004
	],
	"./partners/results/selected-partner-dialog": [
		17341,
		8308,
		7201,
		6516,
		9309,
		5848,
		6452,
		9178,
		670,
		6981,
		3620,
		5460,
		8446,
		8355,
		1363,
		8293,
		7895,
		622,
		7926,
		2615,
		3388,
		3328,
		264,
		7341
	],
	"./partners/results/selected-partner-dialog.tsx": [
		17341,
		8308,
		7201,
		6516,
		9309,
		5848,
		6452,
		9178,
		670,
		6981,
		3620,
		5460,
		8446,
		8355,
		1363,
		8293,
		7895,
		622,
		7926,
		2615,
		3388,
		3328,
		264,
		7341
	],
	"./partners/search-context": [
		96981,
		6981
	],
	"./partners/search-context.ts": [
		96981,
		6981
	],
	"./press/about-openstax/about-openstax": [
		15750,
		8308,
		9593,
		7590,
		3366,
		5750
	],
	"./press/about-openstax/about-openstax.tsx": [
		15750,
		8308,
		9593,
		7590,
		3366,
		5750
	],
	"./press/article/article": [
		39892,
		9593,
		7512,
		951,
		4811,
		9892
	],
	"./press/article/article.scss": [
		64811,
		4811
	],
	"./press/article/article.tsx": [
		39892,
		9593,
		7512,
		951,
		4811,
		9892
	],
	"./press/banner/banner": [
		96934,
		7590,
		9541,
		6934
	],
	"./press/banner/banner.scss": [
		39541,
		9541
	],
	"./press/banner/banner.tsx": [
		96934,
		7590,
		9541,
		6934
	],
	"./press/faq/faq": [
		87432,
		8308,
		9593,
		7590,
		3366,
		1087,
		7432
	],
	"./press/faq/faq.scss": [
		11087,
		1087
	],
	"./press/faq/faq.tsx": [
		87432,
		8308,
		9593,
		7590,
		3366,
		1087,
		7432
	],
	"./press/featured-in/featured-in": [
		30196,
		8308,
		9593,
		7590,
		3366,
		4699,
		196
	],
	"./press/featured-in/featured-in.scss": [
		44699,
		4699
	],
	"./press/featured-in/featured-in.tsx": [
		30196,
		8308,
		9593,
		7590,
		3366,
		4699,
		196
	],
	"./press/helpers": [
		93366,
		8308,
		9593,
		3366
	],
	"./press/helpers.tsx": [
		93366,
		8308,
		9593,
		3366
	],
	"./press/infographic/infographic": [
		48944,
		8308,
		9593,
		7590,
		3366,
		8944
	],
	"./press/infographic/infographic.tsx": [
		48944,
		8308,
		9593,
		7590,
		3366,
		8944
	],
	"./press/mission/inquiries": [
		95925,
		8308,
		7590,
		9552,
		5925
	],
	"./press/mission/inquiries.scss": [
		49552,
		9552
	],
	"./press/mission/inquiries.tsx": [
		95925,
		8308,
		7590,
		9552,
		5925
	],
	"./press/mission/leadership": [
		42749,
		7590,
		1720,
		2749
	],
	"./press/mission/leadership.scss": [
		51720,
		1720
	],
	"./press/mission/leadership.tsx": [
		42749,
		7590,
		1720,
		2749
	],
	"./press/mission/mission": [
		78472,
		8308,
		7590,
		9552,
		1720,
		5925,
		2749,
		8472
	],
	"./press/mission/mission.tsx": [
		78472,
		8308,
		7590,
		9552,
		1720,
		5925,
		2749,
		8472
	],
	"./press/news-mentions/news-mentions": [
		67128,
		8308,
		9593,
		7590,
		3366,
		3508,
		7128
	],
	"./press/news-mentions/news-mentions.tsx": [
		67128,
		8308,
		9593,
		7590,
		3366,
		3508,
		7128
	],
	"./press/page-context": [
		67590,
		7590
	],
	"./press/page-context.tsx": [
		67590,
		7590
	],
	"./press/press": [
		97788,
		8308,
		7201,
		6516,
		9593,
		2480,
		9309,
		7590,
		7512,
		3366,
		951,
		9552,
		1720,
		3508,
		4811,
		9541,
		5925,
		7517,
		1087,
		6573,
		4699,
		2749,
		7171,
		9892,
		6526,
		3447,
		7128,
		7432,
		8472,
		196,
		7788
	],
	"./press/press-releases/press-releases": [
		16526,
		8308,
		9593,
		7590,
		3366,
		3508,
		6573,
		6526
	],
	"./press/press-releases/press-releases.scss": [
		76573,
		6573
	],
	"./press/press-releases/press-releases.tsx": [
		16526,
		8308,
		9593,
		7590,
		3366,
		3508,
		6573,
		6526
	],
	"./press/press.scss": [
		37171,
		7171
	],
	"./press/press.tsx": [
		97788,
		8308,
		7201,
		6516,
		9593,
		2480,
		9309,
		7590,
		7512,
		3366,
		951,
		9552,
		1720,
		3508,
		4811,
		9541,
		5925,
		7517,
		1087,
		6573,
		4699,
		2749,
		7171,
		9892,
		6526,
		3447,
		7128,
		7432,
		8472,
		196,
		7788
	],
	"./press/testimonials/testimonials": [
		93447,
		8308,
		7201,
		6516,
		2480,
		9309,
		7590,
		7517,
		3447
	],
	"./press/testimonials/testimonials.js": [
		93447,
		8308,
		7201,
		6516,
		2480,
		9309,
		7590,
		7517,
		3447
	],
	"./press/testimonials/testimonials.scss": [
		27517,
		7517
	],
	"./renewal-form/renewal-form": [
		18647,
		5848,
		8050,
		3620,
		5460,
		4271,
		1386,
		8647
	],
	"./renewal-form/renewal-form.scss": [
		74271,
		4271
	],
	"./renewal-form/renewal-form.tsx": [
		18647,
		5848,
		8050,
		3620,
		5460,
		4271,
		1386,
		8647
	],
	"./research/components/contact-us": [
		73137,
		9851,
		5174,
		5831,
		3976,
		7504,
		9935,
		3137
	],
	"./research/components/contact-us.tsx": [
		73137,
		9851,
		5174,
		5831,
		3976,
		7504,
		9935,
		3137
	],
	"./research/components/funders": [
		6813,
		9851,
		5174,
		5831,
		3976,
		7504,
		9935,
		6813
	],
	"./research/components/funders.tsx": [
		6813,
		9851,
		5174,
		5831,
		3976,
		7504,
		9935,
		6813
	],
	"./research/components/header": [
		5579,
		8308,
		9851,
		5174,
		5831,
		3976,
		7504,
		9935,
		5579
	],
	"./research/components/header.tsx": [
		5579,
		8308,
		9851,
		5174,
		5831,
		3976,
		7504,
		9935,
		5579
	],
	"./research/components/members": [
		52155,
		9851,
		5174,
		5831,
		2872,
		3976,
		5033,
		9984,
		7541,
		7504,
		6129,
		9935,
		5751,
		2155
	],
	"./research/components/members.tsx": [
		52155,
		9851,
		5174,
		5831,
		2872,
		3976,
		5033,
		9984,
		7541,
		7504,
		6129,
		9935,
		5751,
		2155
	],
	"./research/components/publications": [
		97745,
		8308,
		9851,
		5174,
		5831,
		3976,
		7504,
		9935,
		7745
	],
	"./research/components/publications.tsx": [
		97745,
		8308,
		9851,
		5174,
		5831,
		3976,
		7504,
		9935,
		7745
	],
	"./research/components/research-areas": [
		92738,
		9851,
		5174,
		5831,
		2872,
		3976,
		5033,
		9984,
		7541,
		7504,
		6129,
		9935,
		5751,
		2738
	],
	"./research/components/research-areas.tsx": [
		92738,
		9851,
		5174,
		5831,
		2872,
		3976,
		5033,
		9984,
		7541,
		7504,
		6129,
		9935,
		5751,
		2738
	],
	"./research/components/section": [
		79935,
		9851,
		5174,
		5831,
		3976,
		7504,
		9935
	],
	"./research/components/section.tsx": [
		79935,
		9851,
		5174,
		5831,
		3976,
		7504,
		9935
	],
	"./research/components/tab-accordion-combo": [
		35751,
		2872,
		5033,
		9984,
		7541,
		6129,
		5751
	],
	"./research/components/tab-accordion-combo.tsx": [
		35751,
		2872,
		5033,
		9984,
		7541,
		6129,
		5751
	],
	"./research/research": [
		87024,
		8308,
		484,
		9851,
		5174,
		5831,
		2872,
		3976,
		5033,
		9984,
		7541,
		7504,
		6129,
		9935,
		5751,
		2155,
		7745,
		7159,
		2738,
		5579,
		6813,
		3137,
		7024
	],
	"./research/research.scss": [
		97159,
		7159
	],
	"./research/research.tsx": [
		87024,
		8308,
		484,
		9851,
		5174,
		5831,
		2872,
		3976,
		5033,
		9984,
		7541,
		7504,
		6129,
		9935,
		5751,
		2155,
		7745,
		7159,
		2738,
		5579,
		6813,
		3137,
		7024
	],
	"./research/theme": [
		27504,
		9851,
		5174,
		5831,
		3976,
		7504
	],
	"./research/theme.ts": [
		27504,
		9851,
		5174,
		5831,
		3976,
		7504
	],
	"./separatemap/map-api": [
		56014,
		9431,
		6014
	],
	"./separatemap/map-api.tsx": [
		56014,
		9431,
		6014
	],
	"./separatemap/map-context": [
		6503,
		9431,
		6014,
		6279,
		6503
	],
	"./separatemap/map-context.tsx": [
		6503,
		9431,
		6014,
		6279,
		6503
	],
	"./separatemap/search-box/filters/filters": [
		52115,
		5934,
		2115
	],
	"./separatemap/search-box/filters/filters.scss": [
		95934,
		5934
	],
	"./separatemap/search-box/filters/filters.tsx": [
		52115,
		5934,
		2115
	],
	"./separatemap/search-box/inputs/inputs": [
		51187,
		8308,
		7310,
		1187
	],
	"./separatemap/search-box/inputs/inputs.scss": [
		87310,
		7310
	],
	"./separatemap/search-box/inputs/inputs.tsx": [
		51187,
		8308,
		7310,
		1187
	],
	"./separatemap/search-box/result-box/result-box": [
		15003,
		8308,
		5350,
		5003
	],
	"./separatemap/search-box/result-box/result-box.scss": [
		5350,
		5350
	],
	"./separatemap/search-box/result-box/result-box.tsx": [
		15003,
		8308,
		5350,
		5003
	],
	"./separatemap/search-box/results": [
		6492,
		6279,
		6492
	],
	"./separatemap/search-box/results.tsx": [
		6492,
		6279,
		6492
	],
	"./separatemap/search-box/search-box": [
		83884,
		8308,
		9431,
		7310,
		6014,
		5350,
		6279,
		5934,
		1187,
		5003,
		7499,
		6503,
		2115,
		6492,
		3884
	],
	"./separatemap/search-box/search-box.scss": [
		67499,
		7499
	],
	"./separatemap/search-box/search-box.tsx": [
		83884,
		8308,
		9431,
		7310,
		6014,
		5350,
		6279,
		5934,
		1187,
		5003,
		7499,
		6503,
		2115,
		6492,
		3884
	],
	"./separatemap/separatemap": [
		47076,
		8308,
		9431,
		7310,
		6014,
		5350,
		6279,
		5934,
		1187,
		5003,
		7499,
		6503,
		2115,
		6492,
		5643,
		3884,
		7076
	],
	"./separatemap/separatemap.scss": [
		15643,
		5643
	],
	"./separatemap/separatemap.tsx": [
		47076,
		8308,
		9431,
		7310,
		6014,
		5350,
		6279,
		5934,
		1187,
		5003,
		7499,
		6503,
		2115,
		6492,
		5643,
		3884,
		7076
	],
	"./subjects/new/about-openstax": [
		30888,
		8023,
		5605,
		9127,
		3607,
		888
	],
	"./subjects/new/about-openstax.scss": [
		73607,
		3607
	],
	"./subjects/new/about-openstax.tsx": [
		30888,
		8023,
		5605,
		9127,
		3607,
		888
	],
	"./subjects/new/context": [
		59127,
		8023,
		9127
	],
	"./subjects/new/context.ts": [
		59127,
		8023,
		9127
	],
	"./subjects/new/hero": [
		4662,
		8023,
		2480,
		9127,
		9981,
		4662
	],
	"./subjects/new/hero.scss": [
		29981,
		9981
	],
	"./subjects/new/hero.tsx": [
		4662,
		8023,
		2480,
		9127,
		9981,
		4662
	],
	"./subjects/new/import-info-boxes": [
		24171,
		8023,
		9127,
		9297,
		5370,
		4171
	],
	"./subjects/new/import-info-boxes.js": [
		24171,
		8023,
		9127,
		9297,
		5370,
		4171
	],
	"./subjects/new/import-philanthropic-support": [
		72518,
		8023,
		9127,
		1406,
		483,
		2518
	],
	"./subjects/new/import-philanthropic-support.js": [
		72518,
		8023,
		9127,
		1406,
		483,
		2518
	],
	"./subjects/new/import-subjects-listing": [
		65711,
		8308,
		8023,
		9127,
		985,
		34,
		5711
	],
	"./subjects/new/import-subjects-listing.js": [
		65711,
		8308,
		8023,
		9127,
		985,
		34,
		5711
	],
	"./subjects/new/import-tutor-ad": [
		1453,
		8023,
		5605,
		9127,
		2427,
		7244,
		1453
	],
	"./subjects/new/import-tutor-ad.js": [
		1453,
		8023,
		5605,
		9127,
		2427,
		7244,
		1453
	],
	"./subjects/new/info-boxes": [
		35370,
		8023,
		9127,
		9297,
		5370
	],
	"./subjects/new/info-boxes.scss": [
		99297,
		9297
	],
	"./subjects/new/info-boxes.tsx": [
		35370,
		8023,
		9127,
		9297,
		5370
	],
	"./subjects/new/language-selector-section": [
		49293,
		8308,
		2088,
		9293
	],
	"./subjects/new/language-selector-section.js": [
		49293,
		8308,
		2088,
		9293
	],
	"./subjects/new/load-subjects": [
		77485,
		8308,
		8023,
		484,
		1261,
		5605,
		2480,
		9127,
		5446,
		2088,
		9974,
		9583,
		5254,
		2427,
		8379,
		9297,
		594,
		5884,
		57,
		3607,
		9920,
		5370,
		7244,
		1562,
		9981,
		4974,
		5309,
		3032,
		4146,
		888,
		7485
	],
	"./subjects/new/load-subjects.js": [
		77485,
		8308,
		8023,
		484,
		1261,
		5605,
		2480,
		9127,
		5446,
		2088,
		9974,
		9583,
		5254,
		2427,
		8379,
		9297,
		594,
		5884,
		57,
		3607,
		9920,
		5370,
		7244,
		1562,
		9981,
		4974,
		5309,
		3032,
		4146,
		888,
		7485
	],
	"./subjects/new/philanthropic-support": [
		72864,
		8023,
		9127,
		1406,
		483
	],
	"./subjects/new/philanthropic-support.scss": [
		31406,
		1406
	],
	"./subjects/new/philanthropic-support.tsx": [
		72864,
		8023,
		9127,
		1406,
		483
	],
	"./subjects/new/specific/blog-posts": [
		72717,
		8308,
		7201,
		6516,
		1261,
		5605,
		9309,
		5446,
		9974,
		9583,
		7970,
		8715,
		3228,
		5888,
		2717
	],
	"./subjects/new/specific/blog-posts.scss": [
		35888,
		5888
	],
	"./subjects/new/specific/blog-posts.tsx": [
		72717,
		8308,
		7201,
		6516,
		1261,
		5605,
		9309,
		5446,
		9974,
		9583,
		7970,
		8715,
		3228,
		5888,
		2717
	],
	"./subjects/new/specific/book-viewer": [
		65309,
		5446,
		5254,
		9920,
		5309
	],
	"./subjects/new/specific/book-viewer.scss": [
		19920,
		9920
	],
	"./subjects/new/specific/book-viewer.tsx": [
		65309,
		5446,
		5254,
		9920,
		5309
	],
	"./subjects/new/specific/components/carousel-section": [
		63228,
		8308,
		7201,
		6516,
		1261,
		9309,
		8715,
		3228
	],
	"./subjects/new/specific/components/carousel-section.scss": [
		68715,
		8715
	],
	"./subjects/new/specific/components/carousel-section.tsx": [
		63228,
		8308,
		7201,
		6516,
		1261,
		9309,
		8715,
		3228
	],
	"./subjects/new/specific/context": [
		15446,
		5446
	],
	"./subjects/new/specific/context.ts": [
		15446,
		5446
	],
	"./subjects/new/specific/find-translation": [
		13032,
		3032
	],
	"./subjects/new/specific/find-translation.tsx": [
		13032,
		3032
	],
	"./subjects/new/specific/import-blog-posts": [
		18322,
		8308,
		7201,
		6516,
		1261,
		5605,
		9309,
		5446,
		9974,
		9583,
		7970,
		8715,
		3228,
		5888,
		2717,
		8322
	],
	"./subjects/new/specific/import-blog-posts.js": [
		18322,
		8308,
		7201,
		6516,
		1261,
		5605,
		9309,
		5446,
		9974,
		9583,
		7970,
		8715,
		3228,
		5888,
		2717,
		8322
	],
	"./subjects/new/specific/import-learn-more": [
		93208,
		5446,
		190,
		3187,
		3208
	],
	"./subjects/new/specific/import-learn-more.js": [
		93208,
		5446,
		190,
		3187,
		3208
	],
	"./subjects/new/specific/import-webinars": [
		10571,
		8308,
		5446,
		9974,
		9583,
		7970,
		4797,
		1550,
		571
	],
	"./subjects/new/specific/import-webinars.js": [
		10571,
		8308,
		5446,
		9974,
		9583,
		7970,
		4797,
		1550,
		571
	],
	"./subjects/new/specific/learn-more": [
		53187,
		5446,
		190,
		3187
	],
	"./subjects/new/specific/learn-more.scss": [
		30190,
		190
	],
	"./subjects/new/specific/learn-more.tsx": [
		53187,
		5446,
		190,
		3187
	],
	"./subjects/new/specific/navigator": [
		5884,
		1261,
		5446,
		8379,
		594,
		5884
	],
	"./subjects/new/specific/navigator-context": [
		594,
		1261,
		594
	],
	"./subjects/new/specific/navigator-context.ts": [
		594,
		1261,
		594
	],
	"./subjects/new/specific/navigator.scss": [
		8379,
		8379
	],
	"./subjects/new/specific/navigator.tsx": [
		5884,
		1261,
		5446,
		8379,
		594,
		5884
	],
	"./subjects/new/specific/specific": [
		93279,
		8308,
		8023,
		484,
		1261,
		5605,
		9127,
		5446,
		2088,
		9974,
		9583,
		5254,
		2427,
		8379,
		9297,
		594,
		5884,
		57,
		3607,
		9920,
		5370,
		7244,
		1562,
		4974,
		5309,
		3032,
		4146,
		888,
		3279
	],
	"./subjects/new/specific/specific.scss": [
		91562,
		1562
	],
	"./subjects/new/specific/specific.tsx": [
		93279,
		8308,
		8023,
		484,
		1261,
		5605,
		9127,
		5446,
		2088,
		9974,
		9583,
		5254,
		2427,
		8379,
		9297,
		594,
		5884,
		57,
		3607,
		9920,
		5370,
		7244,
		1562,
		4974,
		5309,
		3032,
		4146,
		888,
		3279
	],
	"./subjects/new/specific/subject-intro": [
		94146,
		1261,
		5446,
		8379,
		594,
		5884,
		57,
		4146
	],
	"./subjects/new/specific/subject-intro.scss": [
		90057,
		57
	],
	"./subjects/new/specific/subject-intro.tsx": [
		94146,
		1261,
		5446,
		8379,
		594,
		5884,
		57,
		4146
	],
	"./subjects/new/specific/translation-selector": [
		74974,
		8308,
		2088,
		4974
	],
	"./subjects/new/specific/translation-selector.tsx": [
		74974,
		8308,
		2088,
		4974
	],
	"./subjects/new/specific/use-english-subject": [
		87970,
		5446,
		9974,
		9583,
		7970
	],
	"./subjects/new/specific/use-english-subject.ts": [
		87970,
		5446,
		9974,
		9583,
		7970
	],
	"./subjects/new/specific/use-found-subject": [
		19974,
		9974
	],
	"./subjects/new/specific/use-found-subject.ts": [
		19974,
		9974
	],
	"./subjects/new/specific/use-translations": [
		69583,
		5446,
		9583
	],
	"./subjects/new/specific/use-translations.ts": [
		69583,
		5446,
		9583
	],
	"./subjects/new/specific/webinars": [
		21550,
		8308,
		5446,
		9974,
		9583,
		7970,
		4797,
		1550
	],
	"./subjects/new/specific/webinars.scss": [
		34797,
		4797
	],
	"./subjects/new/specific/webinars.tsx": [
		21550,
		8308,
		5446,
		9974,
		9583,
		7970,
		4797,
		1550
	],
	"./subjects/new/subjects": [
		67257,
		8308,
		8023,
		484,
		1261,
		5605,
		2480,
		9127,
		5446,
		2088,
		9974,
		9583,
		5254,
		2427,
		8379,
		9297,
		594,
		5884,
		57,
		3607,
		9920,
		5370,
		7244,
		1562,
		9981,
		4974,
		5309,
		3032,
		4146,
		888,
		7257
	],
	"./subjects/new/subjects-listing": [
		40034,
		8308,
		8023,
		9127,
		985,
		34
	],
	"./subjects/new/subjects-listing.scss": [
		50985,
		985
	],
	"./subjects/new/subjects-listing.tsx": [
		40034,
		8308,
		8023,
		9127,
		985,
		34
	],
	"./subjects/new/subjects.scss": [
		91524,
		1524
	],
	"./subjects/new/subjects.tsx": [
		67257,
		8308,
		8023,
		484,
		1261,
		5605,
		2480,
		9127,
		5446,
		2088,
		9974,
		9583,
		5254,
		2427,
		8379,
		9297,
		594,
		5884,
		57,
		3607,
		9920,
		5370,
		7244,
		1562,
		9981,
		4974,
		5309,
		3032,
		4146,
		888,
		7257
	],
	"./subjects/new/tutor-ad": [
		24863,
		8023,
		5605,
		9127,
		2427,
		7244
	],
	"./subjects/new/tutor-ad.scss": [
		32427,
		2427
	],
	"./subjects/new/tutor-ad.tsx": [
		24863,
		8023,
		5605,
		9127,
		2427,
		7244
	],
	"./subjects/new/use-categorized-books": [
		21949,
		8023,
		9127,
		1949
	],
	"./subjects/new/use-categorized-books.js": [
		21949,
		8023,
		9127,
		1949
	],
	"./subjects/subjects": [
		34121,
		4121
	],
	"./subjects/subjects.js": [
		34121,
		4121
	],
	"./team/people-tab/people-tab": [
		15397,
		9333,
		5397
	],
	"./team/people-tab/people-tab.js": [
		15397,
		9333,
		5397
	],
	"./team/people-tab/people-tab.scss": [
		69333,
		9333
	],
	"./team/team": [
		33472,
		2872,
		5033,
		9984,
		7541,
		1261,
		2480,
		6129,
		5628,
		9333,
		3188,
		5397,
		3472
	],
	"./team/team.scss": [
		90807,
		3188
	],
	"./team/team.tsx": [
		33472,
		2872,
		5033,
		9984,
		7541,
		1261,
		2480,
		6129,
		5628,
		9333,
		3188,
		5397,
		3472
	],
	"./webinars/explore-page/explore-page": [
		50768,
		8308,
		8023,
		9593,
		5282,
		1640,
		7445,
		5447,
		9287,
		2837,
		9305,
		4735,
		3087,
		2884,
		768
	],
	"./webinars/explore-page/explore-page.scss": [
		33087,
		3087
	],
	"./webinars/explore-page/explore-page.tsx": [
		50768,
		8308,
		8023,
		9593,
		5282,
		1640,
		7445,
		5447,
		9287,
		2837,
		9305,
		4735,
		3087,
		2884,
		768
	],
	"./webinars/explore-page/heading-and-search-bar": [
		82884,
		8308,
		5447,
		9305,
		2884
	],
	"./webinars/explore-page/heading-and-search-bar.tsx": [
		82884,
		8308,
		5447,
		9305,
		2884
	],
	"./webinars/import-explore-page": [
		78445,
		8308,
		8023,
		9593,
		5282,
		1640,
		7445,
		5447,
		9287,
		2837,
		9305,
		4735,
		3087,
		2884,
		768,
		8445
	],
	"./webinars/import-explore-page.js": [
		78445,
		8308,
		8023,
		9593,
		5282,
		1640,
		7445,
		5447,
		9287,
		2837,
		9305,
		4735,
		3087,
		2884,
		768,
		8445
	],
	"./webinars/import-main-page": [
		21825,
		8308,
		8023,
		9593,
		5282,
		1640,
		7445,
		5447,
		9287,
		2837,
		9305,
		4182,
		2358,
		2963,
		5131,
		1930,
		3723,
		9053,
		4904,
		1825
	],
	"./webinars/import-main-page.js": [
		21825,
		8308,
		8023,
		9593,
		5282,
		1640,
		7445,
		5447,
		9287,
		2837,
		9305,
		4182,
		2358,
		2963,
		5131,
		1930,
		3723,
		9053,
		4904,
		1825
	],
	"./webinars/import-search-page": [
		27954,
		8308,
		8023,
		9593,
		5282,
		1640,
		7445,
		5447,
		9287,
		2837,
		9305,
		4182,
		5131,
		185,
		2654,
		5842,
		3008,
		5573
	],
	"./webinars/import-search-page.js": [
		27954,
		8308,
		8023,
		9593,
		5282,
		1640,
		7445,
		5447,
		9287,
		2837,
		9305,
		4182,
		5131,
		185,
		2654,
		5842,
		3008,
		5573
	],
	"./webinars/main-page/latest-webinars": [
		62654,
		8308,
		9593,
		5282,
		1640,
		7445,
		9305,
		4182,
		5131,
		2654
	],
	"./webinars/main-page/latest-webinars.tsx": [
		62654,
		8308,
		9593,
		5282,
		1640,
		7445,
		9305,
		4182,
		5131,
		2654
	],
	"./webinars/main-page/main-page": [
		54904,
		8308,
		8023,
		9593,
		5282,
		1640,
		7445,
		5447,
		9287,
		2837,
		9305,
		4182,
		2358,
		2963,
		5131,
		1930,
		3723,
		9053,
		4904
	],
	"./webinars/main-page/main-page.tsx": [
		54904,
		8308,
		8023,
		9593,
		5282,
		1640,
		7445,
		5447,
		9287,
		2837,
		9305,
		4182,
		2358,
		2963,
		5131,
		1930,
		3723,
		9053,
		4904
	],
	"./webinars/main-page/past-webinars": [
		29053,
		8308,
		8023,
		9593,
		5282,
		1640,
		7445,
		9287,
		9305,
		2358,
		2963,
		9053
	],
	"./webinars/main-page/past-webinars.tsx": [
		29053,
		8308,
		8023,
		9593,
		5282,
		1640,
		7445,
		9287,
		9305,
		2358,
		2963,
		9053
	],
	"./webinars/main-page/upcoming-webinars": [
		33723,
		8308,
		9593,
		5282,
		1640,
		7445,
		2837,
		9305,
		4182,
		5131,
		3723
	],
	"./webinars/main-page/upcoming-webinars.tsx": [
		33723,
		8308,
		9593,
		5282,
		1640,
		7445,
		2837,
		9305,
		4182,
		5131,
		3723
	],
	"./webinars/search-page/no-results": [
		65842,
		8308,
		9593,
		5282,
		1640,
		7445,
		9305,
		4182,
		5131,
		185,
		2654,
		5842
	],
	"./webinars/search-page/no-results.scss": [
		90185,
		185
	],
	"./webinars/search-page/no-results.tsx": [
		65842,
		8308,
		9593,
		5282,
		1640,
		7445,
		9305,
		4182,
		5131,
		185,
		2654,
		5842
	],
	"./webinars/search-page/search-page": [
		23008,
		8308,
		8023,
		9593,
		5282,
		1640,
		7445,
		5447,
		9287,
		2837,
		9305,
		4182,
		5131,
		185,
		2654,
		5842,
		3008
	],
	"./webinars/search-page/search-page.tsx": [
		23008,
		8308,
		8023,
		9593,
		5282,
		1640,
		7445,
		5447,
		9287,
		2837,
		9305,
		4182,
		5131,
		185,
		2654,
		5842,
		3008
	],
	"./webinars/types": [
		3946,
		3946
	],
	"./webinars/types.ts": [
		3946,
		3946
	],
	"./webinars/view-webinars-page/latest-page": [
		21645,
		8308,
		8023,
		9593,
		5282,
		1640,
		7445,
		5447,
		9287,
		2837,
		9305,
		2358,
		2963,
		7372,
		1645
	],
	"./webinars/view-webinars-page/latest-page.js": [
		21645,
		8308,
		8023,
		9593,
		5282,
		1640,
		7445,
		5447,
		9287,
		2837,
		9305,
		2358,
		2963,
		7372,
		1645
	],
	"./webinars/view-webinars-page/upcoming-page": [
		53786,
		8308,
		8023,
		9593,
		5282,
		1640,
		7445,
		5447,
		9287,
		2837,
		9305,
		2358,
		2963,
		7372,
		3786
	],
	"./webinars/view-webinars-page/upcoming-page.js": [
		53786,
		8308,
		8023,
		9593,
		5282,
		1640,
		7445,
		5447,
		9287,
		2837,
		9305,
		2358,
		2963,
		7372,
		3786
	],
	"./webinars/view-webinars-page/view-webinars-page": [
		47372,
		8308,
		8023,
		9593,
		5282,
		1640,
		7445,
		5447,
		9287,
		2837,
		9305,
		2358,
		2963,
		7372
	],
	"./webinars/view-webinars-page/view-webinars-page.tsx": [
		47372,
		8308,
		8023,
		9593,
		5282,
		1640,
		7445,
		5447,
		9287,
		2837,
		9305,
		2358,
		2963,
		7372
	],
	"./webinars/webinar-cards/paginated-webinar-grid": [
		22963,
		8308,
		8023,
		9593,
		5282,
		1640,
		7445,
		9287,
		2358,
		2963
	],
	"./webinars/webinar-cards/paginated-webinar-grid.scss": [
		22358,
		2358
	],
	"./webinars/webinar-cards/paginated-webinar-grid.tsx": [
		22963,
		8308,
		8023,
		9593,
		5282,
		1640,
		7445,
		9287,
		2358,
		2963
	],
	"./webinars/webinar-cards/webinar-grid": [
		37445,
		8308,
		9593,
		5282,
		1640,
		7445
	],
	"./webinars/webinar-cards/webinar-grid-section": [
		65131,
		8308,
		9593,
		5282,
		1640,
		7445,
		4182,
		5131
	],
	"./webinars/webinar-cards/webinar-grid-section.scss": [
		24182,
		4182
	],
	"./webinars/webinar-cards/webinar-grid-section.tsx": [
		65131,
		8308,
		9593,
		5282,
		1640,
		7445,
		4182,
		5131
	],
	"./webinars/webinar-cards/webinar-grid.scss": [
		61640,
		1640
	],
	"./webinars/webinar-cards/webinar-grid.tsx": [
		37445,
		8308,
		9593,
		5282,
		1640,
		7445
	],
	"./webinars/webinar-context": [
		69305,
		9305
	],
	"./webinars/webinar-context.tsx": [
		69305,
		9305
	],
	"./webinars/webinars": [
		4524,
		9305,
		2291,
		4524
	],
	"./webinars/webinars.scss": [
		32291,
		2291
	],
	"./webinars/webinars.tsx": [
		4524,
		9305,
		2291,
		4524
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 12126;
module.exports = webpackAsyncContext;